import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  useGetGalleryCategoriesQuery,
  useUpdateGalleryCategoryMutation,
  useDeleteGalleryCategoryMutation,
} from "./galleryCategoriesApiSlice";

const EditGalleryCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: categories = [], isLoading } =
    useGetGalleryCategoriesQuery();

  const category = categories.data.find((cat) => cat._id === id);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [order, setOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);

  const [updateCategory, { isLoading: isUpdating, isError, error }] =
    useUpdateGalleryCategoryMutation();

  const [deleteCategory, { isLoading: isDeleting }] =
    useDeleteGalleryCategoryMutation();

  useEffect(() => {
    if (category) {
      setTitle(category.title || "");
      setDescription(category.description || "");
      setOrder(category.order || 0);
      setIsActive(category.isActive ?? true);
    }
  }, [category]);

  if (isLoading) return <p className="container mt-4">Loading...</p>;
  if (!category) return <p className="container mt-4">Category not found</p>;

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      await updateCategory({
        id,
        data: {
          title,
          description,
          order,
          isActive,
        },
      }).unwrap();

      navigate("/dashboard/gallery-categories");
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await deleteCategory(id).unwrap();
        navigate("/dashboard/gallery-categories");
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-body">

          <h2 className="mb-4">Edit Gallery Category</h2>

          <form onSubmit={onSubmit}>

            {/* Title */}
            <div className="mb-3">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            {/* Description */}
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows="3"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* Order */}
            <div className="mb-3">
              <label className="form-label">Order</label>
              <input
                type="number"
                className="form-control"
                value={order}
                onChange={(e) => setOrder(e.target.value)}
              />
            </div>

            {/* Status */}
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
              <label className="form-check-label">
                Active
              </label>
            </div>

            {/* Error */}
            {isError && (
              <div className="alert alert-danger">
                {error?.data?.message || "Update failed"}
              </div>
            )}

            {/* Buttons */}
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isUpdating}
              >
                {isUpdating ? "Updating..." : "Update Category"}
              </button>

              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDelete}
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() =>
                  navigate("/dashboard/gallery-categories")
                }
              >
                Cancel
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
  );
};

export default EditGalleryCategory;
